import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=6f08434e&scoped=true"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=6f08434e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f08434e",
  null
  
)

export default component.exports